/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Home_TitleInputs */

const en_seo_home_title = /** @type {(inputs: Seo_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking, plans and payments for trainers`)
};

const pl_seo_home_title = /** @type {(inputs: Seo_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje, plany i płatności dla trenerów`)
};

/**
* | output |
* | --- |
* | "Booking, plans and payments for trainers" |
*
* @param {Seo_Home_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_home_title = /** @type {((inputs?: Seo_Home_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Home_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_home_title(inputs)
	return en_seo_home_title(inputs)
});